'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = {};

exports.__exports = common;
